module.exports = __webpack_public_path__ + "img/sprinkle-10.ca582350.webp";